export default __webpack_public_path__ + "static/menu-gindakohighball-min4-464e5ef8f466ffb6fbdc49f00d8dd4f7.jpg";